import React from 'react';


class LargeAnnouncementCard extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'LargeAnnouncementCard';
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const data = this.props.data;
    const className = 'card component-large-announcement-card';

    return (
      <section className={className}>

      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} height - A height for the card
 * @prop {String} position - A position for the quote, can be 'top' or 'bottom'
 */
LargeAnnouncementCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  height: React.PropTypes.number,
  position: React.PropTypes.string,
};


export default LargeAnnouncementCard;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/large/LargeAnnouncementCard.jsx
 **/